import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Chart from "react-google-charts";
import { orderBy } from '../common/orderby';
import moment from 'moment'
import Radio from '@material-ui/core/Radio';

import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core/styles';
import { getPlanLocationFromLocation } from './location_helpers';



const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
});


function CostTypeChart(props)
{
  if (!props.schedule || !props.schedule.scheduleCosts)
  return null;
  return <Chart
  width={'500px'}
  height={'300px'}
  chartType="PieChart"
  loader={<div>Loading Chart</div>}
  data={[
    ['Typ', 'Anteil'],
    ['Teamstärke', props.schedule.scheduleCosts.filter(sc => sc.planId !== undefined).map(sc => sc.cost).reduce(function(pv, cv) { return pv + cv; }, 0)],
    ['Persönliche Wünsche', props.schedule.scheduleCosts.filter(sc => sc.workerId !== undefined).map(sc => sc.cost).reduce(function(pv, cv) { return pv + cv; }, 0)]
    
  ]}
  options={{
    title: props.title,
  }}
  rootProps={{ 'data-testid': '1' }}
/>;
}

export class CostStatistics extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleChangeXAxis(event) {
    this.props.actions.setScatterChartAxis('xAxis',event.target.value);
  }
  
  handleChangeYAxis(event) {
    this.props.actions.setScatterChartAxis('yAxis',event.target.value);
  }

  
 pSBC(p,c0,c1,l){
  let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
  if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
  if(!this.pSBCr)this.pSBCr=(d)=>{
      let n=d.length,x={};
      if(n>9){
          [r,g,b,a]=d=d.split(","),n=d.length;
          if(n<3||n>4)return null;
          x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
      }else{
          if(n==8||n==6||n<4)return null;
          if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
          d=i(d.slice(1),16);
          if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
          else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
      }return x};
  h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
  if(!f||!t)return null;
  if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
  else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
  a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
  if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
  else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
}

  getScatterChartData(axis)
  {
    if (axis === this.axisNumAssignments)
    {
      return Object.values(this.props.workers).map(w => this.props.schedule.scheduleAssignments.filter(sa => sa.workerId === w.id).length);
    }
    if (axis === this.axisNumAssignmentsBestLocation)
    {
      return Object.values(this.props.workers).map(w => {
        let workerAssignments = Object.values(this.props.schedule.scheduleAssignments).filter(sa => sa.workerId === w.id);
        let workerAssignmentsBestLoc = workerAssignments.filter(wa => Object.values(this.props.workerLocationAvailabilities).some(wla => wla.workerId === w.id && wla.location === wa.location && wla.availability === 3))
        return workerAssignmentsBestLoc.length;
      });
    }
    if (axis === this.axisPercentAssignmentsBestLocation)
    {
      return Object.values(this.props.workers).map(w => {
        let workerAssignments = Object.values(this.props.schedule.scheduleAssignments).filter(sa => sa.workerId === w.id);
        let workerAssignmentsBestLoc = workerAssignments.filter(wa => Object.values(this.props.workerLocationAvailabilities).some(wla => wla.workerId === w.id && wla.location === wa.location && wla.availability === 3))
        return workerAssignmentsBestLoc.length / workerAssignments.length;
      });
    }
    if (axis === this.axisAvgProperty)
    {
      return Object.values(this.props.workers).map(w => {
        let workerProperties = Object.values(this.props.workerProperties).filter(wp => wp.workerId === w.id);
        let sum = workerProperties.map(wp => wp.value).reduce(function(pv, cv) { return pv + cv; },0);
        return sum/workerProperties.length;
      });
    }
    if (axis === this.axisBestProperty)
    {
      return Object.values(this.props.workers).map(w => {
        let workerProperties = Object.values(this.props.workerProperties).filter(wp => wp.workerId === w.id);
        let min = workerProperties.map(wp => wp.value).reduce(function(pv, cv) { return Math.min(pv,cv); },1000);
        return min;
      });
    }
    if (axis === this.axisWorstProperty)
    {
      return Object.values(this.props.workers).map(w => {
        let workerProperties = Object.values(this.props.workerProperties).filter(wp => wp.workerId === w.id);
        let max = workerProperties.map(wp => wp.value).reduce(function(pv, cv) { return Math.max(pv,cv); },0);
        return max;
      });
    }
    return undefined;
  }

  getWorkerCostData(schedule)
  {
    
    let workers = Object.keys(this.props.workers);
    
    let worker_cost_data = {}; 
      workers.forEach( w => {worker_cost_data[w] =  ({name: this.props.workers[w].name,
        w,
        cost: 
                                 schedule.scheduleCosts
                                      .filter(sc => sc.workerId !== undefined 
                                                  && sc.workerId == w)
                                      .map(sc => sc.cost)
                                      .reduce(function(pv, cv) { return pv + cv; }, 0)
                                      
      
      }  )});
    return worker_cost_data;
  }
  
  getPlanCostData(schedule, dates)
  {
    let planLoc = {};
    Object.values(this.props.plans).forEach(p => planLoc[p.id] = p.location + "/");
    schedule.scheduleAssignments.forEach(sa => planLoc[sa.planId] = sa.location);
    return [
      ['Datum'].concat(Object.values(this.props.allLocations).map(loc => loc.name)),
    ].concat(
      dates.map( d => [moment.utc(d).format("DD.MM.")].concat(Object.values(this.props.allLocations)
                                .map(loc => schedule.scheduleCosts
                                      .filter(sc => sc.planId !== undefined 
                                                  && planLoc[sc.planId] === loc.name
                                                  && this.props.plans[sc.planId].date === d
                                              )
                                      .map(sc => sc.cost)
                                      .reduce(function(pv, cv) { return pv + cv; }, 0)
                                    )
                                  )
          )
    );

  }

  axisNumAssignments = "Anz. eingeteilt";
  axisNumAssignmentsBestLocation = "Anz. eingeteilt an Lieblingsstandort";
  axisPercentAssignmentsBestLocation = "Prozent eingeteilt an Lieblingsstandort";
  axisAvgProperty = "Durchschnittliche Eigenschaft";
  axisBestProperty = "stärkste Eigenschaft";
  axisWorstProperty = "schwächste Eigenschaft";

  interleave(a,b)
  {
    let c = [];
    for (let i=0;i<a.length;i++)
    {
      c.push(a[i]);
      c.push(b[i]);
    }
    return c;

  }

  render() {
    if (!this.props.schedule)
    return null;

    const {scatterChart, classes} = this.props;

    let scatterAxes = [this.axisNumAssignments, this.axisNumAssignmentsBestLocation, this.axisPercentAssignmentsBestLocation, 
      this.axisWorstProperty, this.axisBestProperty, this.axisAvgProperty];

    let scatterData = [];
    let minX,minY,maxX,maxY;
    if (this.props.scatterChart.xAxis && this.props.scatterChart.yAxis)
    {
      let xData = this.getScatterChartData(this.props.scatterChart.xAxis);
      let yData = this.getScatterChartData(this.props.scatterChart.yAxis);
      let tooltip = Object.values(this.props.workers).map(w => w.name);
      let xSpread = 5;
      scatterData = xData.map(function(e, i) {
        return [e+xSpread*(i-xData.length/2)/(xData.length/2), yData[i], tooltip[i]];
      });
      minX = Math.min(xData);
      maxX = Math.max(xData);
      minY = Math.min(yData);
      maxY = Math.max(yData);
      scatterData = [[scatterChart.xAxis, scatterChart.yAxis, { role: "tooltip", type: "string" },]].concat(scatterData);
    }

    let season = this.props.seasons[this.props.schedule.seasonId];

    let planIdsInSchedule  = {};
    for (let schedule of [this.props.schedule, this.props.diffSchedule])
      {
        if (!schedule)
          continue;
        if (!schedule.scheduleAssignments)
          continue;
        for (let ass of schedule.scheduleAssignments)
        {
          planIdsInSchedule[ass.planId] = true;
        }
      }

    
    
    let dates = [...new Set(Object.values(this.props.plans).filter(p => (p.teamRequired || planIdsInSchedule[p.id]) && (p.date >= season.from) && (p.date <= season.to)).map(p => p.date))];
    //console.log({seasonId: this.props.schedule.seasonId, season, s2: this.props.seasons, dates})
    dates = orderBy(dates, d=>d);

    

    let plan_cost_data = this.getPlanCostData(this.props.schedule, dates);
    let diff_plan_cost_data = this.props.diffSchedule && this.props.diffSchedule.scheduleCosts &&this.getPlanCostData(this.props.diffSchedule,dates);

    let plan_cost_data_cmp = plan_cost_data;
    if (diff_plan_cost_data)
    {
      plan_cost_data_cmp = plan_cost_data.map((c, i) => 
        {
          if (i === 0)
            return [c[0]].concat(this.interleave(c.slice(1), diff_plan_cost_data[i].slice(1).map(loc => loc + " Vergl.")));
          else
            return [c[0]].concat(this.interleave(c.slice(1), diff_plan_cost_data[i].slice(1)));
        }
      );
    }

  


    let worker_cost_data = this.getWorkerCostData(this.props.schedule);
    let diff_worker_cost_data = this.props.diffSchedule && this.props.diffSchedule.scheduleCosts && this.getWorkerCostData(this.props.diffSchedule);

    let worker_cost_data_with_diff = {};

    Object.keys(worker_cost_data).forEach(k => 
      {
        worker_cost_data_with_diff[k] = {...worker_cost_data[k], diffCost: diff_worker_cost_data && diff_worker_cost_data && diff_worker_cost_data[k].cost};
      });
    
    //console.log({worker_cost_data});
    //worker_cost_data = orderBy(worker_cost_data, row => row.cost);
    worker_cost_data_with_diff = Object.values(worker_cost_data_with_diff);
    worker_cost_data_with_diff.sort((e1, e2) => e1.cost < e2.cost);
    //console.log({worker_cost_data_with_diff});
    worker_cost_data = [
      ['Person','Kosten'],
    ].concat(worker_cost_data_with_diff.map(c => [c.name, c.cost]));

    diff_worker_cost_data = diff_worker_cost_data && [
      ['Person','Kosten'],
    ].concat(worker_cost_data_with_diff.map(c => [c.name, c.diffCost]));
    

    //console.log({worker_cost_data, diff_worker_cost_data});
    let type_cost_map = {};
    this.props.schedule.scheduleCosts.forEach(sc => {
      if (!sc.type)
        return;
      if (type_cost_map[sc.type] === undefined)
        type_cost_map[sc.type] = 0;

      type_cost_map[sc.type] = type_cost_map[sc.type] + sc.cost;

    });

    let type_cost_data = [
      ['Kostenart','Kosten']]
    .concat(
      Object.keys(type_cost_map).map( k => [k, type_cost_map[k]])
    );
    //console.log({type_cost_map, type_cost_data});

    
  let bar_colors = ["#4285f4", "#db4437", "#f4b400", "#0f9d58", "#ab47bc","#00acc1"].slice(0,Object.keys(this.props.allLocations).length);
  if (diff_plan_cost_data)
  {
    bar_colors = this.interleave(bar_colors, bar_colors.map(c => this.pSBC(0.5, c)));
  }

  let workercostdata = {data: worker_cost_data};
  if (diff_worker_cost_data)
  workercostdata = {diffdata:{new: worker_cost_data, old: diff_worker_cost_data}};

    return (

      <div className="home-cost-statistics">
        <CostTypeChart title="Kostenarten" schedule={this.props.schedule} />
        <CostTypeChart title="Kostenarten Vergleich" schedule={this.props.diffSchedule} />
<div style={{padding:"10px",margin:"10px"}}>

  
<Chart
key={"plancostchart" + diff_plan_cost_data && "diff"}
  width={'100%'}
  height={'300px'}
  chartType="Bar"
  loader={<div>Loading Chart</div>}
  data={plan_cost_data_cmp}
  options={{
    // Material design options
    chart: {
      title: 'Kosten nach Gottesdienst',
      subtitle: ''
    },
    colors: bar_colors,
  }}
  // For tests
  rootProps={{ 'data-testid': '2' }}
/>
</div>



<div style={{padding:"10px",margin:"10px"}}>
<Chart
  {...workercostdata}

key="workercostchart"
  width={'100%'}
  height={worker_cost_data.length*18+'px'}
  
  
  chartType="BarChart"
  loader={<div>Loading Chart</div>}
  
 
  options={{
    legend: 'none',
    diff: { 
      oldData: { 
        //opacity: 1, color: 'yellow', widthFactor: 1,
           tooltip:{
              prefix:'Im Vergleich'
              } 
            }, 
      newData: { 
           tooltip:{
              prefix:'Kosten'
              }
           }
    },
    // Material design options
    chart: {
      title: 'Kosten nach Person',
      subtitle: '',
    },
    chartArea : {height: '100%'},
    //legend: {textStyle: {fontSize: 8}},
    hAxis : { textStyle : { fontSize: 8} },
    vAxis : { textStyle : { fontSize: 8} },
  }}
  // For tests
  rootProps={{ 'data-testid': '2' }}
/>
</div>

<div style={{padding:"10px",margin:"10px"}}>
<Chart
key="typecostchart"
  width={'100%'}
  height={'300px'}
  chartType="Bar"
  loader={<div>Loading Chart</div>}
  data={type_cost_data}
  options={{
    // Material design options
    chart: {
      title: 'Kosten nach Art',
      subtitle: '',
    },
  }}
  // For tests
  rootProps={{ 'data-testid': '2' }}
/>
</div>

<div style={{padding:"10px",margin:"10px",display:"flex"}}>
  
<div>
    <FormLabel component="legend">x-Achse</FormLabel>
    
    <RadioGroup
          aria-label="xAxis"
          name="xAxis"
          className={classes.group}
          value={scatterChart.xAxis}
          onChange={this.handleChangeXAxis.bind(this)}
        >
        
    {scatterAxes.map(axis => 
    <FormControlLabel key={"xAxis"+axis} value={axis} control={<Radio />} label={axis} />
    )}
    </RadioGroup>
    </div>
    <div>
    <FormLabel component="legend">y-Achse</FormLabel>
    
    <RadioGroup
          aria-label="yAxis"
          name="yAxis"
          className={classes.group}
          value={scatterChart.yAxis}
          onChange={this.handleChangeYAxis.bind(this)}
        >
        
    {scatterAxes.map(axis => 
    <FormControlLabel key={"yAxis"+axis} value={axis} control={<Radio />} label={axis} />
    )}
    </RadioGroup>
    </div>
</div>

{scatterData && 
<div>
<Chart
  width={'500px'}
  height={'300px'}
  chartType="ScatterChart"
  loader={<div>Loading Chart</div>}
  data={scatterData}
  options={{
    title: scatterChart.xAxis + " vs " + scatterChart.yAxis,
    vAxis: { title: scatterChart.yAxis, minValue: minY-1, maxValue: maxY+1 },
    hAxis: { title: scatterChart.xAxis, minValue: minX-1, maxValue: maxX+1 },
    legend: 'none',
  }}
  rootProps={{ 'data-testid': '1' }}
/>
</div>
}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    allLocations: state.home.allLocations,
    allLocationGroups: state.home.allLocationGroups,
    plans: state.home.plans,
    workers: state.home.workers,
    workerLocationAvailabilities: state.home.workerLocationAvailabilities,
    workerProperties: state.home.workerProperties,
    seasons: state.home.seasons,
    scatterChart: state.home.scatterChart
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(CostStatistics));



// WEBPACK FOOTER //
// ./src/features/home/CostStatistics.js